/**
 * Pass. Implements DESIGN.md §Components > Cards / Containers, "Pass" and "Compact pass":
 * 24px radius, 24px padding (16px compact), a column with a 16px gap (12px compact): the
 * pass kind as a small caps heading, the body, and a stub pinned to the foot behind a 2px
 * dashed rule. Passes are dark-only, so the card carries `.stars-dark` itself and stays
 * dark on a light page. Reference: stars.css §7 Passes. The aurora, blue and sky materials
 * (gradients, grain, starfield) have no theme token; this is the "plain" material
 * (dark surface, 1px divider). The 76px stub minimum has no step and is left out.
 */
import React, { useId } from 'react';
import { cn } from './cn';

export function Pass({ kind, stub, compact = false, material = 'plain', className, children }) {
  const id = `pass-${useId()}`;
  return (
    <article
      aria-labelledby={id}
      data-material={material}
      className={cn(
        'stars-dark tw-flex tw-flex-col tw-min-w-0 tw-rounded-pass tw-border tw-border-solid tw-border-divider tw-bg-surface tw-text-text tw-shadow-2',
        compact ? 'tw-gap-3 tw-p-4' : 'tw-gap-4 tw-p-6',
        material !== 'plain' && 'tw-border-transparent tw-bg-cover tw-bg-center',
        { plain: '', aurora: 'tw-bg-material-aurora', blue: 'tw-bg-material-blue', sky: 'tw-bg-material-sky' }[material],
        className,
      )}
    >
      <h2 id={id} className="tw-m-0 tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider tw-text-text">
        {kind}
      </h2>
      {children}
      {stub && (
        <div className="tw-mt-auto tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-4 tw-border-0 tw-border-t-2 tw-border-dashed tw-border-divider tw-pt-4">
          {stub}
        </div>
      )}
    </article>
  );
}
